unit UserListScreenType;
{

/* Initial. */

}

interface

uses
  FunctionItemListType, UserItemListType;

type
  TUserListScreenType = class
  private
    fUserItemList: TUserItemListType;
    fFunctionItemList: TFunctionItemListType;
  public
    property UserItemList: TUserItemListType read fUserItemList;
    property FunctionItemList: TFunctionItemListType read fFunctionItemList;
  end;

implementation

end.
